// Navigation scripts
/* eslint-disable id-length, no-unused-vars */

jQuery.noConflict();

(function($j) {
	$j('.skip-link').click(function() {
		var link = $j(this),
			target = link.attr('href'),
			admin_bar = $j('#wpadminbar'),
			header = $j('.header'),
			top_spacing = (admin_bar.length) ? admin_bar.height() + 20 : 20;

		if (header.hasClass('header--is-sticky')) {
			top_spacing = top_spacing + $j('.header').height();
		}

		if (target.charAt(0) == '#') {
			target = '#' + target.split('#')[1];

			if ($j(target).length) {
				$j('html, body').animate({
					scrollTop: $j(target).offset().top - top_spacing
				}, 500).promise().done(function() {
					var position = $j(window).scrollTop();
					$j(target).focus();
					$j(window).scrollTop(position);
				});

				return false;
			}
		}
	});

	var header_wrapper = $j('.header-wrapper');

	if (header_wrapper.length) {
		var breakpoint = 1199,
			width = window.innerWidth || $j(window).width(),
			html_body = $j('html, body'),
			header = $j('.header'),
			logo_wrapper = $j('.logo'),
			menu_toggle = $j('.menu-toggle'),
			primary_menu = $j('.primary-menu'),
			secondary_menu = $j('.secondary-menu');

		// Mobile menu main toggle button

		$j(document).on('click', '.menu-toggle', function() {
			if (!menu_toggle.hasClass('menu-toggle--open')) {
				html_body.addClass('no-scroll');
				logo_wrapper.addClass('logo--menu-open');
				primary_menu.addClass('primary-menu--show');
				secondary_menu.addClass('secondary-menu--show');
				menu_toggle.addClass('menu-toggle--open');
			} else {
				html_body.removeClass('no-scroll');
				logo_wrapper.removeClass('logo--menu-open');
				primary_menu.removeClass('primary-menu--show');
				secondary_menu.removeClass('secondary-menu--show');
				menu_toggle.removeClass('menu-toggle--open');
			}

			return false;
		});

		// Blur after click

		$j('.menu-toggle').on('mouseup touchend', function() {
			$j(this).blur();
		});

		// Making necessary adjustments if the browsers is resized larger than breakpoint

		$j(window).resize(function() {
			var width = window.innerWidth || $j(window).width();

			if (width >= breakpoint) {
				html_body.removeClass('no-scroll');
				logo_wrapper.removeClass('logo--menu-open');
				menu_toggle.removeClass('menu-toggle--open');
				primary_menu.removeClass('primary-menu--show');
			}
		});

		// Sticky header.

		function checkStickyHeader() {
			var scroll_top = ($j('#wpadminbar').length) ? $j(window).scrollTop() + $j('#wpadminbar').height() : $j(window).scrollTop(),
				scrolling_start = ($j('#wpadminbar').length) ? 50 + $j('#wpadminbar').height() : 50,
				window_height = $j(window).height(),
				document_height = $j(document).height();

			if (scroll_top > scrolling_start) {
				header.addClass('header--is-scrolling');
			} else {
				header.removeClass('header--is-scrolling');
			}

			if ((scroll_top + 150) + window_height >= document_height && scroll_top > 100) {
				header.addClass('header--is-hidden');
			} else {
				header.removeClass('header--is-hidden');
			}
		}

		if (header.hasClass('header--is-sticky')) {
			if (width > breakpoint) {
				checkStickyHeader();
			}

			$j(window).resize(function() {
				var width = window.innerWidth || $j(window).width();

				if (width > breakpoint) {
					checkStickyHeader();
				}
			});

			$j(window).scroll(function() {
				checkStickyHeader();
			});
		}
	}
})(jQuery);
